import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { RetryWSModalComponent } from './retry-ws-modal';

export const RetryWSModalModule: string = ng
    .module('archiSmall.components.retryWSModalModule', [
        'ui.bootstrap',
        uiRouter
    ])
    .component('retryWSModalComponent', RetryWSModalComponent)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/commons/components/retry-ws-modal/retry-ws-modal.module.ts